"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.json.stringify.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _useGetTDisplayNameId = require("../../hooks/useGetTDisplayNameId");
var _reactRedux = require("react-redux");
var _actions = require("../../redux/actions");
var _selectors = require("../../redux/selectors");
var _constants = require("../../utils/constants");
var _SelectionPanelModule = _interopRequireDefault(require("../../styles/components/MultiLineChart/SelectionPanel.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const empty = _constants.yAxisTypes.empty;
const SelectionBottomPanel = props => {
  const {
    chartId = "",
    equipmentType = "",
    equipmentId = ""
  } = props;
  const {
    y1AxisSelect,
    y2AxisSelect
  } = (0, _reactRedux.useSelector)(_selectors.getActiveSelectors);
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    options
  } = (0, _useGetTDisplayNameId.useGetTDisplayNameId)({
    chartId,
    equipmentType,
    equipmentId
  });
  const temp = _constants.yAxisTypes.temperature;
  (0, _react.useEffect)(() => {
    const select1 = options.find(o => o.type === temp) || options[0];
    dispatch((0, _actions.setActiveSelect)({
      y1AxisSelect: select1,
      y2AxisSelect: options.find(_ref => {
        let {
          value
        } = _ref;
        return value !== select1.value;
      })
    }));
  }, [JSON.stringify(options)]);
  const setY1AxisSelect = (0, _react.useCallback)(v => {
    dispatch((0, _actions.setActiveSelect)({
      y1AxisSelect: options.find(o => o.value === v),
      y2AxisSelect
    }));
  }, [y2AxisSelect, JSON.stringify(options)]);
  const setY2AxisSelect = (0, _react.useCallback)(v => {
    dispatch((0, _actions.setActiveSelect)({
      y1AxisSelect,
      y2AxisSelect: options.find(o => o.value === v)
    }));
  }, [y1AxisSelect, JSON.stringify(options)]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-column",
    style: {
      marginRight: "30px"
    }
  }, /*#__PURE__*/_react.default.createElement("small", {
    className: _SelectionPanelModule.default.small
  }, "y1-axis"), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-20 ".concat(_SelectionPanelModule.default.selector)
  }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Select, {
    value: y1AxisSelect === null || y1AxisSelect === void 0 ? void 0 : y1AxisSelect.value,
    updateSelector: (_, v) => setY1AxisSelect(v),
    item: {
      type: "select",
      name: "activeSelect"
    },
    variant: "secondary",
    options: options.filter(_ref2 => {
      let {
        value
      } = _ref2;
      return value !== (y2AxisSelect === null || y2AxisSelect === void 0 ? void 0 : y2AxisSelect.value) && value !== empty;
    })
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex-column"
  }, /*#__PURE__*/_react.default.createElement("small", {
    className: _SelectionPanelModule.default.small
  }, "y2-axis"), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-20 ".concat(_SelectionPanelModule.default.selector)
  }, /*#__PURE__*/_react.default.createElement(_paulCorePackage.Select, {
    value: y2AxisSelect === null || y2AxisSelect === void 0 ? void 0 : y2AxisSelect.value,
    updateSelector: (_, v) => setY2AxisSelect(v),
    item: {
      type: "select",
      name: "activeSelect"
    },
    variant: "secondary",
    options: options.filter(_ref3 => {
      let {
        value
      } = _ref3;
      return value !== (y1AxisSelect === null || y1AxisSelect === void 0 ? void 0 : y1AxisSelect.value);
    })
  })))), [y1AxisSelect === null || y1AxisSelect === void 0 ? void 0 : y1AxisSelect.value, y2AxisSelect === null || y2AxisSelect === void 0 ? void 0 : y2AxisSelect.value, options]);
};
var _default = exports.default = SelectionBottomPanel;